module.exports = __webpack_public_path__ + "static/media/sign-in-icon.9c0aded8.svg";